/* Native homepage only: no catalogue data, route simulation or cart state. */
(() => {
  'use strict';
  if (window.LushanCarousel) { window.LushanCarousel.mount(document); return; }
  const instances = new Map();
  function create(root) {
    const slides = [...root.querySelectorAll('.carousel-slide')];
    if (!slides.length) return null;
    const dots = [...root.querySelectorAll('[data-slide-to]')];
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    const options = { signal: abort.signal };
    let index = 0, wanted = !media.matches, hovered = false, focused = false, disposed = false, timer = null;
    function clear() { if (timer !== null) { clearTimeout(timer); timer = null; } }
    function schedule() {
      clear();
      const running = wanted && !media.matches && !hovered && !focused && document.visibilityState === 'visible' && !disposed && slides.length > 1;
      root.dataset.playback = media.matches ? 'reduced-motion' : running ? 'playing' : 'paused';
      if (running) timer = setTimeout(() => show(index + 1, false), 7000);
    }
    function show(next, manual) {
      if (disposed) return;
      index = (next + slides.length) % slides.length;
      if (manual) wanted = false;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      root.dataset.index = String(index);
      root.querySelector('[data-count]').textContent = `${index + 1} / ${slides.length}`;
      root.querySelector('[data-credit-output]').textContent = slides[index].dataset.credit || '';
      if (manual) root.querySelector('[data-status]').textContent = `Diapositive ${index + 1} sur ${slides.length}`;
      schedule();
    }
    root.querySelector('.carousel-controls').hidden = slides.length < 2;
    dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.slideTo), true), options));
    root.addEventListener('mouseenter', () => { hovered = true; schedule(); }, options);
    root.addEventListener('mouseleave', () => { hovered = false; schedule(); }, options);
    root.addEventListener('focusin', () => { focused = true; schedule(); }, options);
    root.addEventListener('focusout', () => queueMicrotask(() => {
      if (!disposed) { focused = root.contains(document.activeElement); schedule(); }
    }), options);
    root.addEventListener('keydown', event => {
      if (event.target?.matches?.('input, textarea, select, [contenteditable="true"]')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }
    }, options);
    document.addEventListener('visibilitychange', schedule, options);
    media.addEventListener('change', () => { if (media.matches) wanted = false; schedule(); }, options);
    show(0, false);
    return { show, dispose() { disposed = true; clear(); abort.abort(); } };
  }
  function mount(scope) {
    scope.querySelectorAll('[data-lushan-carousel]').forEach(root => {
      if (!instances.has(root)) {
        const instance = create(root);
        if (instance) instances.set(root, instance);
      }
    });
  }
  window.LushanCarousel = { mount };
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, root) => {
      if (event.target === root || event.target.contains(root)) { instance.dispose(); instances.delete(root); }
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest?.('.carousel-slide');
    const root = slide?.closest('[data-lushan-carousel]');
    if (root && instances.has(root)) instances.get(root).show(Number(slide.dataset.slideIndex), true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
})();
